import angular from 'angular';
import booksMenu from '../../menu/Menu';

export default angular
  .module('receivablesReport', [booksMenu])
  .controller('receivablesReportController', receivablesReportController).name;

/* @ngInject */ function receivablesReportController(
  $scope,
  $q,
  BooksSvc,
  SERVER,
  BusyScreen,
  Session
) {
  /*---------------------------------------------------------*/
  /* Static array of student options for "Students" dropdown */
  /*---------------------------------------------------------*/
  $scope.studentOptions = [
    { label: 'All', value: 0, show: false },
    { label: 'Active Only', value: 1, show: false },
    { label: 'Inactive Only', value: -1, show: false }
  ];

  /*----------------------------------*/
  /* Static array of grade selections */
  /*----------------------------------*/
  $scope.grades = [
    { label: 15, id: 15 },
    { label: 14, id: 14 },
    { label: 13, id: 13 },
    { label: 12, id: 12 },
    { label: 11, id: 11 },
    { label: 10, id: 10 },
    { label: 9, id: 9 },
    { label: 8, id: 8 },
    { label: 7, id: 7 },
    { label: 6, id: 6 },
    { label: 5, id: 5 },
    { label: 4, id: 4 },
    { label: 3, id: 3 },
    { label: 2, id: 2 },
    { label: 1, id: 1 },
    // The label must be a string for the select to work properly, otherwise it shows up as [Object object]
    { label: '0', id: 0 }
  ];

  /*---------------------*/
  /* Sets default values */
  /*---------------------*/
  $scope.req = { reportFormat: 'PDF', summaryOnly: true, active: 0 };

  $scope.data = {
    selectedReport: Session.getSessionURL('/ReceivablesReport.aspx'),
    summary: '1', //report type
    grades: $scope.grades.map(function (grade) {
      return grade.id;
    })
  };

  /*-----------------------------------------------------------------*/
  /* Watches data.grades and converts array to string for submission */
  /*-----------------------------------------------------------------*/
  $scope.$watch('data.grades', function (grades) {
    $scope.req.grades = grades ? grades.toString() : '';
  });

  /*---------------------------------------------------------------*/
  /* Watches the data.entity model and makes the req.entityID 0 if */
  /* text entered in the typeahead does not match any student name */
  /*---------------------------------------------------------------*/
  $scope.$watch('data.entity', function (entity) {
    entity > 0 ? ($scope.req.entityID = entity) : ($scope.req.entityID = 0);
  });

  /*-------------------------------------------------*/
  /* Formats the fullName and the studentID together */
  /* to be displayed in the student name typeahead.  */
  /*-------------------------------------------------*/
  $scope.studentLabelFunction = function (student) {
    return (
      student.fullName +
      (student.studentID ? ' (' + student.studentID + ')' : '')
    );
  };

  /*****************************************************************************
   * formatName */
  /**
   * Returns the corresponding student names from the getStudentNames() to display
   * in the typeahead.
   * When no match is found will retun empty string.
   *
   * @param  model  Current model value
   * @return        Corresponding item.
   *****************************************************************************/
  $scope.formatName = function (model) {
    if ($scope.students)
      for (var i = 0; i < $scope.students.length; i++) {
        if ($scope.students[i].id == model) {
          return (
            $scope.students[i].name +
            ($scope.students[i].studentID
              ? ' (' + $scope.students[i].studentID + ')'
              : '')
          );
        }
      }
    return '';
  };

  /*****************************************************************************
   * mailer */
  /**
   * Sets the report format to PDF and hides the EXCEL and HTML options, shows
   * the text box for the mailer and sets the default action to the
   * PrintStatementMailer.ashx.
   *****************************************************************************/
  $scope.mailer = function () {
    (($scope.req.reportFormat = 'PDF'),
      ($scope.data.options = 'EXCEL, HTML'),
      ($scope.data.showStatement = true),
      ($scope.req.summaryOnly = false),
      ($scope.data.selectedReport = Session.getSessionURL(
        '/PrintStatementMailer.ashx'
      )));
  };

  /*****************************************************************************
   * detail */
  /**
   * Removes restrictions on the reportFormat, sets the report type to detail,
   * hides the mailer text box and sets the default action to the ReceivablesReport.aspx.
   *****************************************************************************/
  $scope.detail = function () {
    (($scope.req.summaryOnly = false),
      ($scope.data.showStatement = false),
      ($scope.data.selectedReport = Session.getSessionURL(
        '/ReceivablesReport.aspx'
      )),
      ($scope.data.options = ''));
  };

  /*****************************************************************************
   * summary */
  /**
   * Removes restrictions on the reportFormat, sets the report type to summary,
   * hides the mailer text box and sets the default action to the ReceivablesReport.aspx.
   *****************************************************************************/
  $scope.summary = function () {
    (($scope.req.summaryOnly = true),
      ($scope.data.showStatement = false),
      ($scope.data.selectedReport = Session.getSessionURL(
        '/ReceivablesReport.aspx'
      )),
      ($scope.data.options = ''));
  };

  /*----------------------------*/
  /* Validation for date format */
  /*----------------------------*/
  $scope.valOption = {};
  $scope.validateInput = function () {
    return $scope.valOption.validate();
  };

  /*-------------------*/
  /* Load initial data */
  /*-------------------*/
  BooksSvc.getOrganization().then(function (resp) {
    $scope.org = resp.data;

    $scope.getStudentNames = function (text) {
      var defer = $q.defer();
      BooksSvc.findEntities(text, SERVER.BooksDBConstants.ET_STUDENT).then(
        function (resp) {
          $scope.students = resp.data;
          defer.resolve($scope.students);
        }
      );
      return defer.promise;
    };
    BusyScreen.setBusy(false);
  });
}
